export default __webpack_public_path__ + "static/pacific-logo-bb11eb256fa90847d3a68c4e79925a40.jpg";